import React, { memo, useState } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Group, Panel, useDefaultLayout, usePanelRef } from 'react-resizable-panels';

import ClipDownloadsPanel from './ClipDownloadsPanel';
import GripSeparator from '@/shared/components/GripSeparator';
import PlayByPlayTab from './PlayByPlay';

interface ViewingToolsMenuProps {
  open?: boolean;
}

const ViewingToolsMenu: React.FC<ViewingToolsMenuProps> = () => {
  const [downloadPanelExpanded, setDownloadPanelExpanded] = useState(true);
  const theme = useTheme();
  const downloadClipsPanelRef = usePanelRef();

  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    id: 'viewing-tools-menu',
    storage: localStorage,
  });

  return (
    <Box
      sx={{
        height: '100%',
        overflow: 'hidden',
        borderLeft: 'none',
        backgroundColor: theme.palette.background.paper,
        padding: 1,
        paddingLeft: 0,
      }}
    >
      <Group
        orientation="vertical"
        style={{ height: '100%' }}
        defaultLayout={defaultLayout}
        onLayoutChanged={onLayoutChanged}
      >
        <Panel id="viewing-tools-playbyplay">
          <PlayByPlayTab />
        </Panel>

        <GripSeparator orientation="horizontal" />

        <Panel
          id="viewing-tools-downloads"
          minSize="50px"
          defaultSize="200px"
          collapsible
          collapsedSize="50px"
          panelRef={downloadClipsPanelRef}
          onResize={() => {
            const collapsed = downloadClipsPanelRef.current?.isCollapsed() ?? false;
            setDownloadPanelExpanded(!collapsed);
          }}
        >
          <ClipDownloadsPanel
            expanded={downloadPanelExpanded}
            onExpand={() => downloadClipsPanelRef.current?.expand()}
            onCollapse={() => downloadClipsPanelRef.current?.collapse()}
          />
        </Panel>
      </Group>
    </Box>
  );
};

export default memo(ViewingToolsMenu);
